import AccessTokenStore from '../../lib/accessTokenStore'


/**
 * @returns {Boolean} whether an access token is held
 */
export default function hasAccessToken() {
  return Boolean(AccessTokenStore.getAccessToken())
}
